"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssrAnchorMetaName = void 0;
exports.cssrAnchorMetaName = 'naive-ui-style';
